import { render } from "./myRenWu.vue?vue&type=template&id=1d55856a&scoped=true"
import script from "./myRenWu.vue?vue&type=script&lang=js"
export * from "./myRenWu.vue?vue&type=script&lang=js"

import "./myRenWu.vue?vue&type=style&index=0&id=1d55856a&scoped=true&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d55856a"]])

export default __exports__